import { callApi } from "../callApi"

export const getInvitationAcceptToken = (token: string) =>
  callApi<null, null>({
    method: "GET",
    path: `/invitation/accept?token=${token}`,
  })
